module.exports = __webpack_public_path__ + "img/firstchoice.c9666d14.png";